export default __webpack_public_path__ + "static/media/hht1_song_01.275e2cc9.png";